<template>
  <div>
    <v-card class="mx-auto">
      <v-card-text class="pa-5 black--text">
        <v-row class="mx-2">
          <v-col cols="12">
            <div class="font-weight-medium mb-2" style="font-size: 20px">
              Informasi Kegiatan
            </div>
            <v-row>
              <v-col cols="12" lg="4">
                <div class="grey--text body-2">Nama Kegiatan</div>
                <div class="black--text body-1">
                  {{ $getDeepObj(info, 'kegiatan.0') || '' }}
                </div>
              </v-col>
              <v-col cols="12" lg="4">
                <div class="grey--text body-2">Angkatan Pelaksanaan</div>
                <div class="black--text body-1">Angkatan {{ info.gelombang }}</div>
              </v-col>
              <v-col cols="12" lg="4">
                <div class="grey--text body-2">Waktu Pelaksanaan</div>
                <div class="black--text body-1">
                  {{ $getDeepObj(info, 'kegiatan.1') || '' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto mt-5">
      <v-card-text class="pa-5 black--text">
        <v-row class="mx-2 my-1">
          <v-col cols="12">
            <div class="font-weight-medium" style="font-size: 20px">Informasi Pelaksanaan dan Penjadwalan</div>
          </v-col>
          <v-col cols="12">
            <base-form-generator :schema="schema" v-model="form" />
          </v-col>
          <v-col cols="12">
            <div class="font-weight-medium" style="font-size: 20px">Deskripsi Tambahan</div>
            <v-alert
              dense
              icon="mdi-information"
              border="left"
              type="info"
              colored-border
              class="bg-info ma-0 mt-3 no-border"
            >
              <div class="black--text">
                <div class="font-weight-medium">Informasi Pengisian</div>
                <p class="body-2 mb-0">
                  Silakan mengisikan deskripsi tambahan terkait perencanaan kegiatan ini. Dengan menuliskan informasi
                  rentang pelaksanaan di setiap kota/kabupatennya. Termasuk menginformasikan jumlah peserta yang
                  direncanakan, dan sekolahnya apa saja. Misal:
                  <br />
                  1. Kabupaten Bandung (24-25 September); Luring; FSP 10 Orang; Peserta 200 Orang; SMPN 1 Bandung; SMPN
                  2 Bandung.
                  <br />
                  2. Kabupaten Garut (26 September); Luring; FSP 2 orang; Peserta 100 Orang; SMPN 2 Garut; SMPN 4 Garut.
                </p>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12">
            <base-form-generator :schema="schemaDeskripsi" v-model="form" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto mt-5">
      <v-card-text class="pa-5 black--text">
        <v-row class="mx-2 my-1">
          <v-col cols="12">
            <div class="font-weight-medium mb-4" style="font-size: 20px">Informasi Lokasi Kegiatan</div>
            <div class="mt-2">
              <v-list-item v-for="(data, id) in sasaran" :key="id" class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col cols="6">
                      <base-form-generator :schema="schemaSasaran(id)" v-model="sasaran[id]" />
                    </v-col>
                    <v-col cols="6" class="my-auto">
                      <v-icon large color="red" class="ml-2" style="cursor: pointer" @click="onDelSasaran(id)">
                        mdi-close-circle
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
              <div class="text-left">
                <v-btn color="primary" depressed @click="onAddSasaran">
                  <v-icon left size="21">mdi-plus-circle-outline</v-icon>Kota Sasaran
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';

export default {
  name: 'LokakaryaDinasRencana',
  components: { BaseFormGenerator },
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    schema() {
      return [
        {
          type: 'VSelect',
          name: 'k_lokakarya_moda_psp',
          label: 'Moda yang diterapkan',
          labelColor: 'grey',
          placeholder: 'Pilih moda yang diterapkan',
          hint: 'wajib diisi',
          items: this.$mapForMaster(this.$getDeepObj(this, 'masters.lokakarya_moda_psp') || {}),
          outlined: true,
          singleLine: true,
          readonly: this.readOnly,
          dense: true,
          required: true,
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          exist: { status: [2, 3].includes(+this.form.k_lokakarya_moda_psp) },
          type: 'VTextField',
          name: 'lokasi',
          label: 'Lokasi Kegiatan',
          labelColor: 'grey',
          hint: 'wajib diisi',
          outlined: true,
          singleLine: true,
          readonly: this.readOnly,
          hideDetails: true,
          dense: true,
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          type: 'VDatePicker',
          name: 'tgl_mulai_rencana',
          label: 'Tanggal Kegiatan',
          placeholder: 'Pilih tanggal mulai',
          labelColor: 'grey',
          usePrependInnerIcon: 'mdi-calendar-month',
          hint: 'wajib diisi',
          outlined: true,
          singleLine: true,
          disabled: this.readOnly,
          hideDetails: true,
          dense: true,
          required: true,
          grid: { cols: 12, md: 3, sm: 12 },
        },
        {
          type: 'VDatePicker',
          name: 'tgl_selesai_rencana',
          label: 'Tanggal Selesai Kegiatan',
          placeholder: 'Pilih tanggal selesai',
          labelColor: 'white',
          usePrependInnerIcon: 'mdi-calendar-month',
          hint: 'wajib diisi',
          outlined: true,
          singleLine: true,
          disabled: this.readOnly,
          hideDetails: true,
          dense: true,
          required: true,
          grid: { cols: 12, md: 3, sm: 12 },
        },
      ];
    },
    schemaDeskripsi() {
      return [
        {
          type: 'VTextarea',
          name: 'deskripsi_rencana',
          label: 'Detail deskripsi perencanaan kegiatan',
          placeholder: 'Isikan informasi sesuai informasi pengisian di atas',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12 },
          outlined: true,
          dense: true,
          singleLine: true,
          rows: 3,
          autoGrow: true,
        },
      ];
    },
  },
  data() {
    const laporan = this.info.detail || {};
    let sasarans = this.$getDeepObj(laporan, 'psp_kp_pa_lokakarya_dinas_sasarans.data') || [];
    if (sasarans.length) {
      sasarans = sasarans.map((sasaran) => {
        return {
          k_propinsi: sasaran.k_propinsi,
          k_kota: sasaran.k_kota,
        };
      });
    } else {
      sasarans = [{ k_propinsi: '', k_kota: '' }];
    }

    return {
      form: {},
      sasaran: sasarans,
    };
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});

      const laporan = this.info.detail || {};
      for (const sch of [...this.schema, ...this.schemaDeskripsi]) {
        if (sch.name) {
          this.$set(this.form, sch.name, laporan[sch.name] || '');
        }
      }

      let sasarans = this.$getDeepObj(laporan, 'psp_kp_pa_lokakarya_dinas_sasarans.data') || [];
      if (sasarans.length) {
        this.sasaran = sasarans.map((sasaran) => {
          return {
            k_propinsi: sasaran.k_propinsi,
            k_kota: sasaran.k_kota,
          };
        });
      } else {
        sasarans = [{ k_propinsi: '', k_kota: '' }];
      }

      this.$nextTick(() => {
        this.sasaran = sasarans;
      });
    },

    getValue() {
      let params = Object.assign({ jenis: 'rencana', k_lokakarya_kegiatan_psp: this.info.k_laporan }, this.form);

      if (+params.k_lokakarya_moda_psp === 1) {
        delete params['lokasi'];
      }

      params.sasaran = [];
      for (const sasaran of this.sasaran) {
        if (sasaran.k_kota) {
          params.sasaran.push(sasaran);
        }
      }

      return params;
    },

    configSasaran(id) {
      const M_PROPINSI = this.masters.propinsi || {};
      const M_KOTA = this.masters.kota || {};

      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: [`Kabupaten/Kota ke-${id + 1}`, ``],
        placholder: ['Pilih Provinsi', 'Pilih Kabupaten / Kota'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 6 }, { cols: 6 }],
      };
    },

    schemaSasaran(id) {
      return [
        {
          type: 'cascade',
          labelColor: 'grey',
          configs: this.configSasaran(id),
          grid: { cols: 12 },
        },
      ];
    },

    onAddSasaran() {
      this.sasaran.push({ k_propinsi: '', k_kota: '' });
    },

    onDelSasaran(id) {
      this.sasaran.splice(id, 1);
    },
  },
};
</script>
